
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class PatientCenterInfo extends Vue {
  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("centerInfo");
  }

  get UniversityPatientCount(): number {
    return this.rawChartData[0]?.UniversityPatientCount || 0;
  }

  get ClinicalPatientCount(): number {
    return this.rawChartData[0]?.ClinicalPatientCount || 0;
  }

  get PracticePatientCount(): number {
    return this.rawChartData[0]?.PracticePatientCount || 0;
  }



  async mounted() {
    try {
      await dataVisualizationModule.loadAll("centerInfo");
    } catch (error) {
      console.error("Failed to load data", error);
    }
  }
}
